export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const LOGOUT_USER = "LOGOUT_USER";
